import React from 'react';

import IMG_1 from '../../../Images/gallery/torres/img_1.png';
import IMG_2 from '../../../Images/gallery/torres/img_2.png';
import IMG_3 from '../../../Images/gallery/torres/img_3.png';
import IMG_4 from '../../../Images/gallery/torres/img_4.png';
import IMG_5 from '../../../Images/gallery/torres/img_5.png';

export const Torres_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>TORRES 10</span>,
  },
];

export const Title_Video = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>La Mezcla Eres Tú</span>,
  },
];

export const Title_Video_2 = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>Abogado - Diseñadora</span>,
  },
];

export const Title_Video_3 = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>Conferencista - Programador</span>,
  },
];

export const Title_4 = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>FOTO FIJA</span>,
  },
];

export const Torres_Gallery = [
  { src: IMG_1, imgWidth: '38%' },
  { src: IMG_2, imgWidth: '60%' },
  { src: IMG_3, imgWidth: '50%' },
  { src: IMG_4, imgWidth: '50%' },
  { src: IMG_5, imgWidth: '50%' },
];
